/**
 * @generated SignedSource<<64e7eff0aa4b9facdda3aa75e7bf8cc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userRootNodes_QueryFragment$data = {
  readonly Admin: {
    readonly LearnV2: {
      readonly RootNodesWithTreeStatesForUser: ReadonlyArray<{
        readonly rootNode: {
          readonly id: string;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"userRootNodeItem_RootNodesWithTreeStateTypeFragment">;
      }>;
    };
  };
  readonly " $fragmentType": "userRootNodes_QueryFragment";
};
export type userRootNodes_QueryFragment$key = {
  readonly " $data"?: userRootNodes_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userRootNodes_QueryFragment">;
};

import userRootNodes_RefetchQuery_graphql from './userRootNodes_RefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "name"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": userRootNodes_RefetchQuery_graphql
    }
  },
  "name": "userRootNodes_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LearnV2AdminSchema",
          "kind": "LinkedField",
          "name": "LearnV2",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "name",
                  "variableName": "name"
                },
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId"
                }
              ],
              "concreteType": "RootNodesWithTreeStateType",
              "kind": "LinkedField",
              "name": "RootNodesWithTreeStatesForUser",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "LearnOpportunityV2",
                  "kind": "LinkedField",
                  "name": "rootNode",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "userRootNodeItem_RootNodesWithTreeStateTypeFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a929b59864d87d1cfff92065d9e68d18";

export default node;
